import React from 'react';

const TEMPLATES_URL =
	'https://www.atlassian.com/software/confluence/templates/categories/project-planning';

// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
export const paragraphConstructor = (intlStr: React.ReactNode[]) => <p>{intlStr}</p>;
export const anchorConstructor = (intlStr: React.ReactNode[]) => (
	<a href={TEMPLATES_URL} target="_blank">
		{intlStr}
	</a>
);
